function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "D91CF67A-36D2-4F08-AF4C-DFF2EBCD327C");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\u9875\\u9762-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "1.-Predict-Important-Motifs",
  transform: "translate(-82.000000, -949.000000)",
  stroke: "#AFAFAF",
  strokeWidth: 2.625
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_collapse",
  transform: "translate(84.000000, 951.000000)"
}, /*#__PURE__*/React.createElement("line", {
  x1: 14,
  y1: 6.59966329,
  x2: 0,
  y2: 6.59966329,
  id: "\\u76F4\\u7EBF"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "\\u77E9\\u5F62",
  strokeLinejoin: "round",
  transform: "translate(6.611111, 6.599663) rotate(-135.000000) translate(-6.611111, -6.599663) ",
  points: "1.94444444 1.93299662 11.2777778 1.93299662 11.2777778 11.26633"
}))));

const SvgIcCollapse = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "18px",
  height: "18px",
  viewBox: "0 0 18 18",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcCollapse, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-collapse.2b031919.svg";
export { ForwardRef as ReactComponent };